import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import {
  FunnelDefaultConversionRateSetting,
  PermissionKey,
} from '../../../../../utils/apollo/graphqlSchema';
import { FieldLabel, VerticalField } from '../../../../../components/Form';
import ExclusiveButtonGroup, {
  IExclusiveButtonOption,
} from '../../../../../components/ExclusiveButtonGroup';
import { IReportSettingsFormState } from '../types';
import usePermission from '../../../../../utils/hooks/permissionHooks';
import { theme } from '../../../../../styles/theme';

const OptionsGroup = styled(ExclusiveButtonGroup)`
  width: 180px;
  height: 24px;
`;
const Label = styled.div`
  font-weight: 500;
  color: ${theme.colors.mainBlue};
`;

const funnelDefaultConversionOptions: IExclusiveButtonOption<FunnelDefaultConversionRateSetting>[] =
  [
    {
      label: 'Relative',
      value: FunnelDefaultConversionRateSetting.Relative,
      hint: 'Calculate conversion rate based on previous step',
    },
    {
      label: 'Absolute',
      value: FunnelDefaultConversionRateSetting.Absolute,
      hint: 'Calculate conversion rate based on first step',
    },
  ];

const FunnelReportSettings = () => {
  const { checkIsPermitted } = usePermission();
  const isPermittedToEditAdminSetting = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AdminSettingEdit],
  });

  const { control } = useFormContext<IReportSettingsFormState>();

  return (
    <Controller
      name="funnel.defaultConversionRate"
      control={control}
      render={({ field }) => (
        <VerticalField noMargin>
          <FieldLabel>Default Conversion Rate</FieldLabel>
          {isPermittedToEditAdminSetting ? (
            <OptionsGroup
              selectedValue={field.value}
              onChange={field.onChange}
              options={funnelDefaultConversionOptions}
            />
          ) : (
            <Label>
              {
                funnelDefaultConversionOptions.find(
                  (option) => option.value === field.value,
                )?.label
              }
            </Label>
          )}
        </VerticalField>
      )}
    />
  );
};

export default FunnelReportSettings;
